<template>
  <div class="card maxCaptl">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col blue">
              <h3><i class="fas fa-gavel"></i>Set Bid Validity</h3>
            </div>
            <div class="text-right">
              <!-- <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i>  Set/Trader</a> -->
            </div>
        </div>
      </div>
      <!-- <small>Current Bid Validity {{currentBidValidity}} Days</small> -->
      <div class="input-group mb-3">
        <!-- <input  type="number" class="form-control" max="3" min="1" placeholder="# Of Days" v-model="bidValidity"> -->
        <span class="input-group-text days" id="basic-addon2">Days</span>
         <select class="form-control cursor-pointer" v-model="bidValidity">
            <option value="">Set Bid Validity</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        <div class="input-group-append">
            <button :disabled="bidValidity == 0" @click="setBidValidity()" type="button">
              <i v-if="!loading" class="fas fa-check"  v-bind:class="bidValidity == 0 ? 'fa-disabled' : ''"></i>
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
              </button>
        </div>
      </div>
  </div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";

export default {
  name: "setbidvalidity",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.bidValidity = this.bidSettings.bidValidity;
        this.currentBidValidity = this.bidSettings.bidValidity;
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken:null,
      bidValidity : "",
      currentBidValidity : 0,
      loading : false

    };
  },
  methods: {
    getBidValidity(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/outstandingbid",
            auth
        )
        .then(result => {
          console.log(result);
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    setBidValidity(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/organization/bid-settings",
          {
            bidValidity: this.bidValidity,
            orgType : "BID"
          },
          auth
        )
        .then(response => {
          console.log(response);
          this.loading = false;
          this.currentBidValidity = this.bidValidity;
          this.$alert(this.appMessages.bidValidityUpdated);
        })
        .catch(e => {
          console.log(e);
          this.loading = false;

        });
    },
    navigateListPage(){
      window.location.href = "/bidside/bid";
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        //this.getBidValidity();
      }
    }); 
  }
};
</script>